/**
 * Document Audit + member-SOR state setters for the Uploads Simulator. Pure
 * `setState` wrappers only — fetching, token guards, object-URL lifecycle and
 * abort handling live on the controller.
 */
class DocumentAuditDelegate {
    setMemberQuery(memberQuery) {
        this.setState({memberQuery});
    }

    setMemberResults(memberResults) {
        this.setState({memberResults});
    }

    setMemberSearchLoading(memberSearchLoading) {
        this.setState({memberSearchLoading});
    }

    setSelectedMember(selectedMember) {
        this.setState({selectedMember});
    }

    setJobs(jobs) {
        this.setState({jobs});
    }

    setJobsLoading(jobsLoading) {
        this.setState({jobsLoading});
    }

    setJobsError(jobsError) {
        this.setState({jobsError});
    }

    setSelectedJobId(selectedJobId) {
        this.setState({selectedJobId});
    }

    /** Full replacement of the preview slice `{objectUrl, mimeType, loading, error}`. */
    setPreview(preview) {
        this.setState({preview});
    }

    setMemberSorModalOpen(memberSorModalOpen) {
        this.setState({memberSorModalOpen});
    }

    setMemberSorLoading(memberSorLoading) {
        this.setState({memberSorLoading});
    }

    /** `{clientId, memberName, loadedAt} | null` — the unsaved member-loaded SOR indicator. */
    setMemberSorSource(memberSorSource) {
        this.setState({memberSorSource});
    }
}

export default DocumentAuditDelegate;
